import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-m-leoe2formulas",
  "use": "icon-soc-m-leoe2formulas-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-m-leoe2formulas\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<circle cx=\"300\" cy=\"280\" r=\"28\" /><path d=\"M288 160h320l160 160v544H288V160z\" /><path d=\"M608 160v160h160\" fill=\"#fff\" fill-opacity=\".35\" /><path d=\"M352 448h320v48H352zM352 544h256v48H352z\" fill=\"#fff\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-m-leoe2formulas.svg
// module id = bDBB
// module chunks = 478